import React, { useCallback, useEffect } from 'react';
import { useHistory, useParams } from 'react-router';
import { Token } from '../../model/Model';
import { ActionButton } from './ActionButton';
import { useCheckinState, useReportState } from '../../state/state';

export const CheckoutButton = () => {
    const history = useHistory();
    const {token} = useParams<Token>();
    const {loading, checkOut, activeCheckin} = useCheckinState();
    const {reset: resetReport} = useReportState();

    const onClick = useCallback(() => {
        if (token && checkOut) {
            resetReport();
            checkOut(token);
        }
    }, [token, checkOut]);

    useEffect(() => {
        if (token && !activeCheckin) {
            history.replace(`/checkout/${token}`);
        }
    }, [token, activeCheckin]);

    return (
        <ActionButton text={loading ? 'Checking Out...' : 'Check Out Now'}
                      disabled={loading} onClick={onClick}/>
    );
};
